import _ from 'lodash';

export const titleCaseString = (string: string) => {
  return string
    ?.replace(/(_|-)/g, ' ')
    ?.trim()
    ?.replace(/\w\S*/g, function (str) {
      return str?.charAt(0)?.toUpperCase() + str?.substr(1);
    })
    ?.replace(/([a-z])([A-Z])/g, '$1 $2')
    ?.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');
};

export const trimSpacesInPayload = (payload: any) => {
  const formattedPayload: Record<string, any> = {};

  if (!_.isEmpty(payload)) {
    for (const key of Object.keys(payload)) {
      if (typeof payload[key] === 'string') {
        formattedPayload[key] = payload[key].trim();
      } else {
        formattedPayload[key] = payload[key];
      }
    }
  }
  return formattedPayload;
};
